import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ResultRegistrationEffects } from './result-registration-flow.effects';
import { resultRegistrationFlowFeature } from './result-registration-flow.reducer';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(resultRegistrationFlowFeature),
        EffectsModule.forFeature([ResultRegistrationEffects]),
    ],
})
export class ResultRegistrationFlowStateModule {}
